import React from 'react';
import { Link } from 'react-router-dom';
import { toDateString } from '../../../util/DateUtility';
import Has from '../../../component/Permission/Has';
import { G_EXPORT_TRANSACTION, PAY_OVERVIEW_STOP_PAYMENT, U_VIEW_USERS, U_USER_ADMIN } from '../../../config/PermissionTypes';
import { getUrl } from '../../../util/EfupUtility';

export default function RoleOverview(props) {
    const { role } = props;

    if (role === null) {
        return <div>Role not found.</div>
    }

    //check for null dates
    const createdDate = role.createdDate ? toDateString(role.createdDate) : "N/A";

    const rolePermissions = role.permissions ? role.permissions : [];
    
    // List of available Dashboard permissions
    let roleDashboardPerms = [];

    // List of available Payments tables permissions
    let rolePaymentsPerms = [];
    if (rolePermissions.includes(G_EXPORT_TRANSACTION)) rolePaymentsPerms.push({displayName: "Export Data", testId: "payment-permission-export-data"});
    if (rolePermissions.includes(PAY_OVERVIEW_STOP_PAYMENT)) rolePaymentsPerms.push({displayName: "Stop Payment", testId: "payment-permission-stop-payment"});

    // List of available User Admin permissions
    let roleUserAdminPerms = [];
    if (rolePermissions.includes(U_VIEW_USERS)) roleUserAdminPerms.push({displayName: "View Users", testId: "user-admin-permission-view-users"});
    if (rolePermissions.includes(U_USER_ADMIN)) roleUserAdminPerms.push({displayName: "User Management", testId: "user-admin-permission-user-management"});

    const hasPermissions = roleDashboardPerms.length > 0 || rolePaymentsPerms.length > 0 || roleUserAdminPerms.length > 0;

    return (
        <div className="efup-role-side-panel-overview" data-testid="efup-role-side-panel-overview">        
            <div className="efup-side-panel-line">
                <table className="table table-borderless" data-testid="efup-overview-tab-body">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="efup-side-panel-label">Role Name:</td>
                            <td className="efup-side-panel-data" data-testid="efup-overview-tab-name">{role.roleName}</td>
                        </tr>
                        <tr>
                            <td className="efup-side-panel-label">Description:</td>
                            <td className="efup-side-panel-data" data-testid="efup-overview-tab-customerId">{role.description}</td>
                        </tr>
                        <tr>
                            <td className="efup-side-panel-label">Created Date:</td>
                            <td className="efup-side-panel-data" data-testid="efup-overview-tab-create-date">{createdDate}</td>
                        </tr>
                    </tbody>
                </table>
                <div className="efup-sub-header" data-testid="efup-overview-tab-permissions-section">Permissions</div>
                { hasPermissions ? 
                    <div>
                        <div className="row">
                            { roleDashboardPerms.length > 0 &&
                                <div className="col" data-testid="efup-overview-dashboard-permissions-section">
                                    <p className="efup-side-panel-label">Dashboard</p>
                                    <div className="efup-permissions-list-item">
                                        <ul>
                                            { roleDashboardPerms.map((perm, i) => {
                                                return <li key={i}  data-testid={ perm.testId }><label className="efup-permissions-list-item-label">
                                                    { perm.displayName }
                                                </label></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="row">
                            { rolePaymentsPerms.length > 0 &&
                                <div className="col" data-testid="efup-overview-payments-permissions-section">
                                    <p className="efup-side-panel-label">Payment Pages</p>
                                    <div className="efup-permissions-list-item">
                                        <ul>
                                            { rolePaymentsPerms.map((perm, i) => {
                                                return <li key={i} data-testid={ perm.testId }><label className="efup-permissions-list-item-label">
                                                    { perm.displayName }
                                                </label></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="row">
                            { roleUserAdminPerms.length > 0 &&
                                <div className="col" data-testid="efup-overview-useradmin-permissions-section">
                                    <p className="efup-side-panel-label">User Admin</p>
                                    <div className="efup-permissions-list-item">
                                        <ul>
                                            { roleUserAdminPerms.map((perm, i) => {
                                                return <li key={i} data-testid={ perm.testId }><label className="efup-permissions-list-item-label">
                                                    { perm.displayName }
                                                </label></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    : <div className="efup-side-panel-data">No permissions assigned to this user.</div>
                }
            </div>
            {!role.standardRole &&
                <Has permission={U_USER_ADMIN}>
                    <div className="ocButtons">
                        <Link tabIndex="-1" to={getUrl(props.companyNumber, `/roles/${encodeURIComponent(role.roleName)}/edit`)} state={{ companyNumber: props.companyNumber, editRole: role }}>
                            <button type="button" className="oc-blue-btn" data-testid="efup-overview-tab-edit-role-button">Edit Role</button>
                        </Link>
                    </div>
                </Has>
            }
        </div>
    );
}